

















import { Component, Vue } from "vue-property-decorator";
import VersionBackModule from "@/store/modules/VersionBack-module";
import { UtilsString } from "@/utils/utils-string";
import { LocalStorageService } from "@/shared/services/LocalStorageConfig-service";
import { RouterNames } from "@/router/routernames";
import usuarioModule from "@/store/modules/usuario-module";
@Component({
  components: {},
})
export default class Home extends Vue {
  public dialogNewVersion: boolean = false;
  public height = (25 * this.$vuetify.breakpoint.height) / 100;
  public created() {
    //VersionBackModule.getVersionFront().then(() => this.isnewversion());
  }

  public mounted() {
    // Remove initial loading
    const appLoading = document.getElementById("loading-bg");
    if (appLoading) {
      appLoading.style.display = "none";
    }
    usuarioModule.getmiusuario().then((x) => {
      this.$router.push({
        name: RouterNames.usuariosfichajes,
        params: { id: x.id },
      });
    });
  }

  public isnewversion() {
    //Estoy en una versión mas antigua?
    VersionBackModule.GetVersionEnv();
    let vlocal = LocalStorageService.getVersion()
      .trim()
      .replace(".", "")
      .replace(".", "");
    let vEnv = VersionBackModule.versionfrontEnv
      .trim()
      .replace(".", "")
      .replace(".", "");
    let vfront = VersionBackModule.versionfront
      .trim()
      .replace(".", "")
      .replace(".", "");
    //si la version de front que devulve el back es mas nueva que la que tiene en cache/entorno
    if (Number.parseInt(vfront) > Number.parseInt(vEnv)) {
      //Pulsamos F5 para refrescar la pagina
      document.location.reload(true);
    }

    if (UtilsString.IsNullOrWhiteSpace(vlocal)) {
      this.dialogNewVersion = false;
      LocalStorageService.setVersion(VersionBackModule.versionfrontEnv);
      return false;
    }
    //si la version que tiene en el fichero de entorno es mas nueva que la ultima que ha ejecutado
    if (Number.parseInt(vEnv) > Number.parseInt(vlocal)) {
      this.dialogNewVersion = true;
      LocalStorageService.setVersion(VersionBackModule.versionfrontEnv);
    } else {
      this.dialogNewVersion = false;
      LocalStorageService.setVersion(VersionBackModule.versionfrontEnv);
      return false;
    }
    return true;
  }

  public goto(name: string) {
    this.$router.push({ name: name });
  }
}
